/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{AComputedField as e}from"./AComputedField.js";class r extends e{constructor(e){super(),this._field=e}resize(e){throw new Error("Method not implemented.")}read(e,r){return e.readAttribute(this._field)}readWithDefault(e,r){return e.readAttribute(this._field)}hasArcadeDependency(e){return!1}}export{r as CachedField};
